let language = {
    THIRD_PARTY_REGIST_FORM_NICKNAME_LABEL: "昵称",
    THIRD_PARTY_REGIST_FORM_NICKNAME_PLACEHOLDER: "请输入您的昵称",
    THIRD_PARTY_REGIST_FORM_EMAIL_LABEL: "电子邮箱",
    THIRD_PARTY_REGIST_FORM_EMAIL_PLACEHOLDER: "请输入您的社交电子邮箱地址",
    THIRD_PARTY_REGIST_FORM_ERROR_TIP1: "请输入正确的电子邮箱地址",

    THIRD_PARTY_REGIST_FORM_SIGNUP_BTN: "注册",
};

export { language }